export const LABEL_GITHUB = 'GitHub'
export const LABEL_LOCAL = 'Local'
export const LABEL_SAMPLES = 'Samples'
